const s = {
  name: "AbTesting",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 40" style="enable-background:new 0 0 32 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14,0H0v6h2v29c0,2.8,2.2,5,5,5c2.8,0,5-2.2,5-5V6h2V0z M4,4H2V2h10v2h-2v22H4V4z M4,28h6v7c0,1.7-1.3,3-3,3
			c-1.7,0-3-1.3-3-3V28z"/>
		<path class="st0" d="M32,0H18v6h2v29c0,2.8,2.2,5,5,5c2.8,0,5-2.2,5-5V6h2V0z M22,4h-2V2h10v2h-2v8h-6V4z M22,14h6v21
			c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3V14z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as AbTesting
};
